<template>
    <div class="popup" :class="{ active: popupShow }">
        <div class="popup__inner">
            <div class="popup__certification">
                <div class="popup__tit">
                    <h2>예약</h2>
                    <button type="button" class="popup__close" @click="popupBtn"><img src="@/assets/resource/icon/close.svg" alt=""></button>
                </div>
                <div class="popup__body">
                    <h3 class="mt-none mb-none">진료과</h3>
                    <p>{{info.DEPT_NM}}({{$store.getters.getHostNm}})</p>

                    <h3 class="mb-none">진료의사</h3>
                    <p>{{info.MEDR_NM}} 교수님</p>

                    <h3>진료일 선택</h3>
                    <div class="month__wrap">
                        <div class="month__calendar type2">
                            <kr_Calendar :classList="classList" @getClass="selectDoctor" @selectDate="selectDate"/>

                            <ul class="profile__tit-list">
                                <li class="profile__tit-item">예약마감</li>
                                <li class="profile__tit-item">예약가능</li>
                                <li class="profile__tit-item">선택</li>
                            </ul>
                        </div>
                    </div>

                    <h3>진료시간 선택</h3>
                    <div class="popup-btn-wrap">
                        <!-- 선택시 active -->
                        <template v-for="(time, idx) in timeList" :key="idx">
                            <button type="button" :class="{active: selectedTime.MED_TM === time.MED_TM}" @click="setInfomation(time)" >{{ time.MED_TM }}</button>
                        </template>
                    </div>

                    <div class="botton-wrap">
                        <button type="button" class="sub-button c-main" @click="popupBtn">취소</button>
                        <button type="button" class="main-button c-main" @click="reservation">예약</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                popupShow: false,
                info: '',
                selectedDept: {},
                selectedDoctor: {},
                selectedDate: {},
                selectedTime: {},
                reservationInfo: {},
                classList: [],
                timeList: [],
                patInfo: {},
                rplFlag: 'N',           // 대리인 예약 여부
            }
        },
        components: {
        },
        mounted() {
        },
        methods: {
            setPatInfo(){
                if(this.$store.state.patInfoStore.ptNo){
                    this.rplFlag = 'Y'
                }else{
                    this.$store.state.patInfoStore.patName = this.$store.state.myInfoStore.name
                    this.$store.state.patInfoStore.patBirth = this.$store.state.myInfoStore.birth
                    this.$store.state.patInfoStore.patHpNo = this.$store.state.myInfoStore.hpNo
                    this.$store.state.patInfoStore.ptNo = this.$store.state.myInfoStore.ptNo
                    this.$store.state.patInfoStore.email = this.$store.state.myInfoStore.email

                }

                this.patInfo.name = this.$store.state.patInfoStore.patName
                this.patInfo.birth = this.$store.state.patInfoStore.patBirth
                this.patInfo.ptNo = this.$store.state.patInfoStore.ptNo
                this.patInfo.hpNo = this.$store.state.patInfoStore.patHpNo
                this.patInfo.email = this.$store.state.patInfoStore.email

                this.patInfo.birth = `${this.patInfo.birth.slice(0, 4)}.${this.patInfo.birth.slice(4, 6)}.${this.patInfo.birth.slice(6, 8)}`

            },
            init(){
                this.info = ''
                this.selectedDoctor = {}
                this.selectedDate = {}
                this.selectedTime = {}
                this.reservationInfo = {}
                this.classList = []
                this.timeList = []
            },
            popupBtn() {
                this.popupShow = !this.popupShow
                if(this.popupShow){
                    this.setPatInfo()
                    // this.selectDept(this.info)
                    this.selectDoctor(this.info)

                    this.selectedDept = this.info
                    this.info.deptNm = this.info.DEPT_NM
                }else{
                    this.init()
                }
            },
            async selectDept(dept) {
                this.timeList = []
                this.selectedTime = {}
                this.selectedDoctor = {}
                this.classList = []
                this.sortCheck = false

                await this.axios.get(this.api.doctor.deptDoctorList,
                    {
                        params: {
                            deptCd: dept.MED_DEPT_CD
                            , exposeYn: 'Y'
                            , drSid: dept.MEDR_SID
                        }
                    })
                    .then(res => {
                        this.selectedDept = dept

                        this.selectDoctor(res.data.doctorList[0])
                    })
                    .catch(err => {
                        console.error(err)
                    })
            },
            selectDoctor(doctor, selDt) {
                this.selectedDate = {}
                this.selectedTime = {}

                const name = doctor.MEDR_NM ? doctor.MEDR_NM : doctor.name
                const deptCd = doctor.MED_DEPT_CD ? doctor.MED_DEPT_CD : doctor.deptCd
                const drSid = doctor.MEDR_SID ? doctor.MEDR_SID : doctor.drSid
                // 테스트(송석원)
                // const deptCd = 'VECVS'
                // const drSid = '1019623'
                if (this.selectedDoctor.drSid != drSid) {
                    this.selectedDoctor = {}
                    this.selectedDoctor.name = name
                    this.selectedDoctor.deptCd = deptCd
                    this.selectedDoctor.drSid = drSid
                    // this.selectedDoctor.fastDt = doctor.fastDt
                    // this.selectedDoctor.empId = doctor.empId
                }

                if (!selDt) {
                    const today = new Date()
                    const year = today.getFullYear()
                    const month = ('0' + (today.getMonth() + 1)).slice(-2)

                    selDt = year + month
                }

                this.axios.get(this.api.doctor.schedule,
                    {
                        params: {
                            drSid: drSid,
                            IN_MED_YM: selDt,
                            deptCd: deptCd,
                        }
                    })
                    .then(res => {
                        const data = res.data
                        const schedule = data.schedule

                        this.classList = []
                        if(schedule && schedule.length > 0){
                            // schedule 을 반복문으로 돌려서 classList에 넣어준다.
                            for(let i of schedule){
                                let dayClass = ''

                                if(i.CLNC_YN === 'N' && i.HOLY_YN === 'N' && i.NSP_RSN_TP_CD === 'N') {
                                    if(i.MED_RSV_YN === 'N') {
                                        dayClass = 'end'
                                    }else if(i.MED_RSV_YN === 'Y') {
                                        dayClass = 'possibility'
                                    }
                                }

                                this.classList.push({
                                    text: i.MED_DT.replaceAll('-', ''),
                                    MED_RSV_YN: i.MED_RSV_YN,
                                    HOLY_YN: i.HOLY_YN,
                                    calClass: dayClass
                                })

                            }
                        }
                    })
                    .catch(err => {
                        console.error(err)
                    })

            },
            selectDate(date) {
                this.selectedTime = {}
                this.selectedDate = date

                this.axios.get(this.api.appointment.doctorDayTime,
                    {
                        params: {
                            IN_DR_SID: this.selectedDoctor.drSid,
                            IN_MED_DT: date.text,
                            IN_MED_DEPT_CD: this.selectedDoctor.deptCd,
                        }
                    })
                    .then(res => {
                        this.timeList = []

                        if(res.data) {
                            this.timeList = res.data

                        }
                    })
                    .catch(err => {
                        console.error(err)
                    })

            },
            setInfomation(time){
                const date = String(this.selectedDate.text)
                this.selectedTime = {}
                this.reservationInfo = {}

                const dt = `${date.slice(0, 4)}-${date.slice(4, 6)}-${date.slice(6, 8)}`

                this.selectedTime = time
                this.selectedTime.selDt = dt
                this.selectedTime.printDt = `${dt} (${ this.$commonUtils.getDayOfWeek(date)}) ${time.MED_TM}`

                this.reservationInfo.IN_MED_DT = this.selectedDate.text
                this.reservationInfo.IN_MED_TM = time.MED_TM.replace(':', '')
                this.reservationInfo.IN_DR_SID = this.selectedDoctor.drSid
                this.reservationInfo.IN_MED_DEPT_CD = this.selectedDoctor.deptCd
            },
            reservation(){
                if(Object.keys(this.reservationInfo).length == 0){
                    alert('예약정보를 선택해주시길 바랍니다.')
                    return
                }
                
                if(confirm('예약하시겠습니까?')){
                    let reservationParam = {
                        "IN_MED_DEPT_CD": this.reservationInfo.IN_MED_DEPT_CD,
                        "IN_MEDR_SID": this.reservationInfo.IN_DR_SID,
                        "IN_MED_DT": this.reservationInfo.IN_MED_DT,
                        "IN_MED_TM": this.reservationInfo.IN_MED_TM,
                    }

                    if(this.rplFlag == 'Y'){
                        reservationParam.rplPtNo = this.patInfo.ptNo
                    }

                    this.axios.post(this.api.appointment.reservation, reservationParam).then(res => {
                        if (res.data.code == 'error') {
                            alert(res.data.rtn_msg)

                        } else {
                            alert('예약이 완료되었습니다.')

                            // 예약 완료 후 patInfoStore 초기화
                            this.$store.state.patInfoStore = {}

                            this.$store.state.reserveStore.reserve = {
                                patName: this.patInfo.name,
                                ptNo: this.patInfo.ptNo,
                                patHpNo: this.patInfo.hpNo,
                                patEmail: this.patInfo.email,
                                deptCd: this.selectedDoctor.deptCd,
                                deptName: this.selectedDept.deptNm,
                                drName: this.selectedDoctor.name,
                                drSid: this.selectedDoctor.drSid,
                                medDt: this.selectedTime.selDt,
                                medTm: this.selectedTime.MED_TM,
                                RPY_PACT_ID: res.data.result,
                                rplFlag: this.rplFlag
                            }

                            this.popupBtn()
                        }
                    })
                }
            },
        },
    }
</script>